import { CrudState } from "@/store/Crud/State";
const EMPTY_PRAXIS_OVERVIEW = {
    summary: { totalDistanceInMeters: 0, totalTimeInSeconds: 0 },
    routes: [],
    taskGroups: [],
};
export class State extends CrudState {
    validity = {};
    canUseKiPilotTheory = null;
    praxisOverview = EMPTY_PRAXIS_OVERVIEW;
    youtubeLink = "";
    // KI-Pilot Theory explanations
    explanationLoading = false;
    explainVolume = null;
    explainPreExamPerformance = null;
    explainPerformance = null;
    explainGeneralOverview = null;
    explainCategory = null;
}
